// shared css require needs to come first so component css can override shared css without needing !important
require('@alltrails/modules/PhotoUpload/sharedCss.css');
require('@alltrails/modules/ActivityUpload/sharedCss.css');
require('@alltrails/shared/sharedCss.css');

import { lazy } from 'react';
import FooterWrapper from 'components/FooterWrapper';
import GlobalActions from 'components/GlobalActions';
import NavigationWrapper from 'components/NavigationWrapper';
import withSuspense from '../hocs/withSuspense';

// we need our CSS immediately so it renders correctly from the server
import 'components/AlgoliaSearchBox';

// import css in your controller using @css = 'trail-page-css'
const TrailPage = lazy(() => import('components/TrailPage'));
const AlgoliaSearchBoxErbWrapper = lazy(() => import('components/AlgoliaSearchBox/AlgoliaSearchBoxErbWrapper'));

const ReactRailsUJS = require('react_ujs');

const context = {
  AlgoliaSearchBoxErbWrapper: withSuspense(AlgoliaSearchBoxErbWrapper, 'AlgoliaSearchBoxErbWrapper'),
  FooterWrapper,
  GlobalActions,
  NavigationWrapper,
  TrailPage: withSuspense(TrailPage, 'TrailPage')
};

ReactRailsUJS.getConstructor = className => context[className];
